import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import {
  Book,
  Isbn,
  LooseObject,
  CartItem,
  News,
  Address,
  Order,
  Cart
} from "@/types";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    dev: false as boolean,
    books: Array<Book>(),
    news: Array<News>(),
    isbn: Array<Isbn>(),
    topics: Array<LooseObject>(),
    authors: Array<LooseObject>(),
    keywords: Array<LooseObject>(),
    //  cart: { amount: 0, items: {} } as Cart,
    cart: { total: 0, shipping: 0, items: [] } as Cart,
    address: {} as Address,
    shipping: 0 as number,
    orders: Array<Order>(),
    search: "" as string,
    lastPage: 0 as number,
    offset: [] as Array<number>,
    totalOffset: 0 as number,
    page: {} as LooseObject,
    admin: false as boolean,
    imgpath: "https://beta.apropos-verlag.ch/images/" as string,
    imgpath_news: "https://beta.apropos-verlag.ch/images/news/" as string,
    width: 0 as number,
    issearching: false as boolean
  },
  mutations: {
    setData(state, d) {
      if (d.books) {
        store.commit("setBooks", d.books);
      }
      if (d.topics) {
        store.commit("setTopics", d.topics);
      }
      if (d.news) {
        store.commit("setNews", d.news);
      }
      if (d.cart) {
        store.commit("setCart", d.cart);
      }
      if (d.address) {
        store.commit("setAddress", d.address);
      }
    },
    setCart(state, c) {
      if (c != "") {
        state.cart.items = c;
      } else {
        state.cart.items = [];
      }
    },
    setAddress(state, u) {
      if (u != "") {
        state.address = u;
      }
    },
    setShipping(state, s) {
      state.cart.shipping = s;
    },
    setTotal(state, t) {
      state.cart.total = t;
    },
    setOrder(state, address) {
      let order: Order = {
        cart: Object.assign({}, state.cart),
        oid: 0,
        status: 0,
        payment: 0,
        date: false,
        senddate: false
      };
      state.orders.push(order);
      state.cart.items = [];
      store.commit("setAddress", address);
    },
    setOrderId(state, oid) {
      state.orders[state.orders.length - 1].oid = oid;
    },
    setBooks(state, b) {
      state.books = b;
    },
    addBook(state, b) {
      state.books.push(b);
    },
    setNews(state, n) {
      state.news = n;
    },
    addNews(state, n) {
      state.news.push(n);
    },
    setIsbn(state, i) {
      state.isbn = i;
    },
    setTopics(state, t) {
      state.topics = t;
    },
    setKeywords(state, k) {
      state.keywords = k;
    },
    setAuthors(state, a) {
      state.authors = a;
    },
    addTopic(state, t) {
      state.topics.push(t);
    },
    addKeyword(state, k) {
      state.keywords.push(k);
    },
    addAuthor(state, a) {
      state.authors.push(a);
    },
    updateSearch(state, search: string) {
      state.search = search;
    },
    currentPage(state, add: boolean) {
      add ? state.lastPage++ : (state.lastPage = 0);
    },
    setCurrentPage(state, page: LooseObject) {
      state.page = page;
      state.issearching = true;
    },
    addOffset(state, key: number) {
      state.offset.push(key);
    },
    setTotalOffset(state, o) {
      state.totalOffset = o;
    },
    deleteOffset(state) {
      state.offset = [];
    },
    saveCart(state) {
      const server: string = state.dev ? "http://localhost:8888" : "";
      axios.post(server + "/backend/functions/function.saveCart.php", {
        cart: state.cart
      });
      //        .then(response =>  store.commit("setCart", response.data) );
      //console.log(response.data)
    },
    /*  updateCartCount(state) {
      let i: number = 0;
      for (let item of Object.values(state.cart)) {
        i += item.amount;
      }
      state.cart.amount = i;
    },*/
    addToCart(state, book) {
      let found = state.cart.items.find(function(element: CartItem) {
        if (element.item == book) {
          element.amount++;
        }
        return element.item == book;
      });
      if (!found) {
        state.cart.items.push({ item: book, amount: 1 });
      }
      store.commit("saveCart");
      /*
      if (book.bid in state.cart.items) {
        state.cart.items[book.bid].amount += 1;
      } else {
        state.cart.items[book.bid] = { item: book, amount: 1 };
      }
      state.cart.amount += 1;*/
    },
    removeFromCart(state, book) {
      store.state.cart.items.splice(
        store.state.cart.items.findIndex((e: CartItem) => e.item === book),
        1
      );
    },
    reserveIsbn(state, book) {
      state.isbn[book.isbn] = book.bid;
    },
    setWindowSize(state, width) {
      state.width = width;
    },
    searching(state, val: boolean) {
      state.issearching = val;
    }
  },
  actions: {},
  modules: {},
  getters: {
    cartCounter: state => {
      let i: number = 0;
      for (let item of state.cart.items) {
        i += item.amount; // 1, "string", false
      }
      return i;
      //  return state.cart.amount;
    },
    search: state => {
      return state.search;
      //  return state.cart.amount;
    },
    lastPage: state => {
      return state.lastPage;
      //  return state.cart.amount;
    },
    width: state => {
      return state.width;
    },
    issearching: state => {
      return state.issearching;
    }
  }
});
